import React, { useEffect, useRef } from 'react';
import './NavMenus.css';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../LanguagePrefix';

function NavResources({ onClose, buttonRef }) {
    const menuRef = useRef(null);
    const { t } = useTranslation();
    const langPrefix = useLanguagePrefix();


    return (
        <div className='nav-menu-popup' ref={menuRef} style={{ width: "270px", left: -100 }}>
            <div className='d-flex justify-content-center' style={{ marginTop: -10 }}>
                <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.67777 2.24264C12.0209 -0.100505 15.8199 -0.100505 18.1631 2.24264L25.5981 9.67767C29.3779 13.4575 26.7009 19.9203 21.3554 19.9203H13.9204L6.48538 19.9203C1.13996 19.9203 -1.53705 13.4575 2.24274 9.67767L9.67777 2.24264Z" fill="#fff" />
                </svg>
            </div>
            <div className='nav-content'>
                <div className='nav-grid-1col'>
                    <a href={`${langPrefix}/resources/`} style={{ textDecoration: 'none' }} className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <label>{t('All Resources')}</label>
                            <small style={{ textAlign: 'start' }}>{t('Guides, tools, and insights')}</small>
                        </div>
                    </a>
                    <a href={`${langPrefix}/support/`} style={{ textDecoration: 'none' }} className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <label>{t('Support')}</label>
                            <small style={{ textAlign: 'start' }}>{t('Help from our team')}</small>
                        </div>
                    </a>
                    <a href={`${langPrefix}/tools/`} style={{ textDecoration: 'none' }} className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <label>{t('Tools')}</label>
                            <small style={{ textAlign: 'start' }}>{t('Online calculators for hotels')}</small>
                        </div>
                    </a>
                </div>
            </div>
        </div >
    );
}

export default NavResources;